<template>

    <v-panel :can-close="false">
        <div class="tabs">
            <a class="tab" :class="{ active: tab === 'settings' }" href="#" @click.prevent="tab = 'settings'">Settings</a>
            <a class="tab" :class="{ active: tab === 'blocks' }" href="#" @click.prevent="tab = 'blocks'">Blocks</a>
            <a class="tab" v-if="mode !== 'template' && templates.length" :class="{ active: tab === 'templates' }" href="#" @click.prevent="tab = 'templates'">Templates</a>
        </div>
        <template v-if="tab === 'settings' && mode !== 'template'">
            <v-section-sender expanded />
            <v-section-email type="replyto" />
            <v-section-email v-if="mode === 'automatic'" type="bcc" />
            <v-section-recipient v-if="mode === 'automatic'" />
            <v-section-unsub-group />
            <v-section-format />
        </template>
        <template v-if="tab === 'settings' && mode === 'template'">
            <v-section-format expanded />
        </template>
        <template v-if="tab === 'blocks'">
            <v-section-blocks-default expanded />
            <v-section-blocks-custom />
        </template>
        <template v-if="tab === 'templates'">
            <v-section-templates />
        </template>
    </v-panel>

</template>

<style scoped lang="scss">

    .tabs {
        background: #fff;
        border-bottom: 1px solid $color-rule;
        display: flex;
        .tab {
            @include font-medium(13px);
            border-right: 1px solid $color-rule-light;
            color: $color-text;
            display: block;
            padding: 15px;
            text-align: left;
            text-decoration: none;
            transition: all .3s;
            &:hover, &.active {
                color: $color-primary;
            }
        }
    }

</style>

<script>

import Panel from './Panel';
import SectionBlocksCustom from './sections/SectionBlocksCustom';
import SectionBlocksDefault from './sections/SectionBlocksDefault';
import SectionEmail from './sections/SectionEmail';
import SectionFormat from './sections/SectionFormat';
import SectionRecipient from './sections/SectionRecipient';
import SectionSender from './sections/SectionSender';
import SectionTemplates from './sections/SectionTemplates';
import SectionUnsubGroup from './sections/SectionUnsubGroup';

export default {

    components: {
        'v-panel': Panel,
        'v-section-blocks-custom': SectionBlocksCustom,
        'v-section-blocks-default': SectionBlocksDefault,
        'v-section-email': SectionEmail,
        'v-section-format': SectionFormat,
        'v-section-recipient': SectionRecipient,
        'v-section-sender': SectionSender,
        'v-section-templates': SectionTemplates,
        'v-section-unsub-group': SectionUnsubGroup,
    },

    data() {
        return {
            tab: 'settings',
        }
    },

    computed: {

        mode() {
            return this.$store.getters['builder/mode'];
        },

        templates() {
            return this.$store.getters['builder/templates'];
        },

    },

}

</script>